import styled from 'styled-components';
import React, { ReactNode } from 'react';
import { footerCss } from 'src/styles/footerCss';

const FooterWrap = styled.footer<FooterStyleProps>`
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'normal')};
  color: ${(props) => (props.color ? props.color : 'black')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '400')};
  letter-spacing: ${(props) => (props.letterSpacing ? props.letterSpacing : '-1px')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'transparent')};

  ${footerCss}
`;

export interface FooterStyleProps {
  fontSize?: string;
  letterSpacing?: string;
  backgroundColor?: string;
  color?: string;
  fontWeight?: number;
  textAlign?: string;
}

interface FooterProps {
  children: ReactNode;
  styles?: FooterStyleProps;
}

const Footer = (props: FooterProps) => {
  const { styles, children } = props;
  return (
    <FooterWrap {...styles}>
      <ul>

        {children}
      
        <li>(주)데이터유니버스 서울 영등포구 여의대로 70</li>
        <li>사업자등록번호 : 382-86-01230 / 통신판매업신고 : 제2020-서울영등포-1315호</li>
      </ul>

      {/* <br />
      <span>(주)데이터유니버스 서울 영등포구 여의대로 70</span>
      <br />
      <span>사업자등록번호 : 382-86-01230 / 통신판매업신고 : 제2020-서울영등포-1315호</span> */}
    </FooterWrap>
  );
};

export default Footer;
